import infoupdReducers from './reducers';
export { default as infoupdOperations } from './operations';
export { default as infoupdTypes } from './types';
export default infoupdReducers;
